<template>
  <section class="content">
    <div class="row">
      <div class="col-md-12">
        <div class="box box-default">
          <div class="box-body">
            <ul class="nav">
              <li class="pull-right">
                <h4>
                    <span class="label label-primary" v-on:click="next">
                      &gt;
                    </span>
                </h4>
              </li>
              <li class="pull-right">
                <h4>
                    <span class="label label-primary">
                      <strong>{{ reel.identificativo }}</strong>
                    </span>
                </h4>
              </li>
              <li class="pull-right">
                <h4>
                    <span class="label label-primary" v-on:click="prev">
                      &lt;
                    </span>
                </h4>
              </li>
              <li class="pull-right" style="margin-right: 10px;">
                <router-link :to="{ name: 'fundsShow', params: { id: fund.id }}" tag="h4">
                    <span class="label label-primary">
                        <strong>{{ fund.denominazione }}</strong>
                    </span>
                </router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <reels-form :reel="reel" :disabled="disabled" @activate-mod="activateMod()" @save-archive-web="saveArchiveWeb()" @click="updateReel()"
                    :showLabels="true" :showSave="true"></reels-form>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h3 class="box-title">Sequenze</h3>
          </div>
          <div class="box-body">
            <v-server-table url="" :columns="columns" :options="options" name="sequences" ref="sequences"
                            @row-click="showSequence">
              <template slot="abstract" slot-scope="props">
                <div class="form-group">
                  <textarea class="form-control" :ref="'abstract-'+props.row.id" v-on:click.stop=""
                            :disabled="!$accessControl.isOperator($store.state.profile.profile)"
                  style="height: 150px;">{{props.row.abstract}}</textarea>
                </div>
              </template>
              <template slot="actions" slot-scope="props">
                <div>
                  <button class="btn btn-danger btn-sm"
                          v-on:click.stop="removeSequence(props.row.id)"
                          v-if="$accessControl.isOperator($store.state.profile.profile)">
                    <i class="fa fa-trash"></i>
                  </button>
                  <button class="btn btn-success btn-sm" v-on:click.stop="updateSequence(props.row)"
                          v-if="$accessControl.isOperator($store.state.profile.profile)">
                    <i class="fa fa-check"></i>
                  </button>
                </div>
              </template>
            </v-server-table>
          </div>

          <div class="box-footer">
            <div class="row">
              <div class="col-md-2 col-md-offset-10 text-right">
                <button class="btn btn-primary btn-block" v-on:click.prevent="storeSequence"
                        v-if="disabled && $accessControl.isOperator($store.state.profile.profile)">
                  Nuova sequenza
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import types from '../../store/mutation-types'
  import reelsApi from '../../api/reels'
  import reelsForm from './Form.vue'
  import sequencesApi from '../../api/sequences'
  import Sequence from '../../models/sequence'

  export default {

    components: {
      reelsForm
    },

    data () {
      return {
        reel: false,
        fund: false,
        abs: '',
        columns: [
          'progressivo', 'abstract', 'actions'
        ],
        options: {
          saveState: false,
          headings: {},
          sortable: [
            'progressivo'
          ],
          columnsClasses: {
            'progressivo': 'progressivo'
          },
          requestFunction: function (query) {
            return reelsApi.sequences(this.$route.params.id, query)
          }
        },
        disabled: true,
        interval: null,
        showMap: false
      }
    },

    beforeCreate () {
      reelsApi.show(this.$route.params.id)
        .then((response) => {
          this.reel = response
          this.fund = response.fund.data
          this.$store.commit(types.SET_ACTUAL_REEL, _.cloneDeep(response))
          this.$store.commit(types.SET_ACTUAL_FUND, response.fund.data)
        })
    },

    created () {
      this.$store.commit(types.SET_HEADER_STATE, {
        pageTitle: 'Scheda bobina',
        createButton: {
          display: true,
          text: 'Nuova bobina',
          to: '/reel'
        }
      })
      this.$emit('addBackgroundColor', 'rgb(202,94,66)')
      this.interval = setInterval(() => {
        if (!this.disabled) {
          reelsApi.update(this.$route.params.id, this.reel)
        }
      }, process.env.AUTOSAVE_TIMEOUT)
    },
    beforeDestroy () {
      clearInterval(this.interval)
    },
    methods: {
      showSequence (row) {
        this.$router.push({name: 'sequencesShow', params: {id: row.row.id, showMap: false}})
      },
      activateMod () {
        this.disabled = !this.disabled
      },
      updateReel () {
        this.loader = true
        return reelsApi.update(this.$route.params.id, this.reel)
          .then((response) => {
            toastr.success('La bobina è stata salvata correttamente')
            this.loader = false
            this.disabled = true
          })
          .catch((response) => {
            this.loader = false
          })
      },
      saveArchiveWeb () {
        this.loader = true
        return reelsApi.saveArchiveWeb(this.$route.params.id)
          .then((response) => {
            toastr.success('La bobina è stata salvata correttamente')
            this.loader = false
            this.disabled = true
          })
          .catch((response) => {
            this.loader = false
          })
      },
      prev () {
        reelsApi.prev(this.reel.id)
          .then((response) => {
            this.$router.push({name: 'reelsShow', params: {id: response.data}})
          })
      },
      next () {
        reelsApi.next(this.reel.id)
          .then((response) => {
            this.$router.push({name: 'reelsShow', params: {id: response.data}})
          })
      },
      storeSequence () {
        this.loader = true
        sequencesApi.store(new Sequence(false, {reel_id: this.reel.id}))
          .then((response) => {
            toastr.success('La sequenza è stata inserita correttamente')
            this.$refs.sequences.refresh()
          })
          .catch((response) => {
            this.loader = false
          })
      },
      removeSequence (id) {
        if (confirm('Sei sicuro di procedere?')) {
          this.loading = true
          sequencesApi.delete(id)
            .then((response) => {
              this.$refs.sequences.refresh()
              toastr.success('La sequenza è stata rimossa correttamente')
              this.loading = false
            })
            .catch((response) => {
              this.loading = false
            })
        }
      },
      updateSequence (sequence) {
        this.loader = true
        var sequenceToSave = new Sequence(false, sequence)
        sequenceToSave.abstract = this.$refs['abstract-' + sequenceToSave.id].value
        sequencesApi.update(sequenceToSave.id, sequenceToSave)
          .then((response) => {
            toastr.success('La sequenza è stata salvata correttamente')
            this.loader = false
          })
          .catch((response) => {
            this.loader = false
          })
      }
    }
  }
</script>

<style>
  .progressivo {
    width: 120px;
  }

  .label-primary {
    cursor: pointer;
  }

  tr td:nth-child(1) {
    width: 10%;
  }

  tr td:nth-child(2) {
    width: 80%;
  }
</style>



// WEBPACK FOOTER //
// src/components/reels/Show.vue